import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Check, Gift, Crown, Star } from "lucide-react";

const freeFeatures = [
  "Sample lessons",
  "Basic games",
  "3 videos",
  "Limited printables",
  "Explore all categories",
];

const premiumFeatures = [
  "All content unlocked",
  "Premium games",
  "Unlimited worksheets",
  "New weekly content",
  "Ad-free learning",
  "Priority support",
];

const PlanPreview = () => {
  return (
    <section className="py-12 md:py-16 bg-cyan-50">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-8"
        >
          <h2 className="text-3xl md:text-4xl font-fredoka font-bold text-gray-800 mb-2">
            Choose Your Plan 🎉
          </h2>
          <p className="text-gray-600 font-quicksand text-base md:text-lg">
            Start free anytime and upgrade when ready!
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-4xl mx-auto items-stretch">
          {/* Free Plan */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            whileHover={{ y: -4 }}
            className="bg-white rounded-3xl border-2 border-cyan-200 shadow-md hover:shadow-xl transition-all p-6 md:p-7 flex flex-col h-full"
          >
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-2xl bg-cyan-100 flex items-center justify-center">
                <Gift className="w-6 h-6 text-cyan-600" />
              </div>
              <div>
                <h3 className="font-fredoka font-bold text-2xl text-gray-800">
                  Free Plan 🎁
                </h3>
              </div>
            </div>

            <div className="mb-5">
              <span className="text-4xl md:text-5xl font-fredoka font-bold text-gray-900">
                ₹0
              </span>
              <span className="text-gray-500 font-quicksand ml-2">forever</span>
            </div>

            <ul className="space-y-3 mb-6 flex-grow">
              {freeFeatures.map((f) => (
                <li key={f} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-cyan-100 flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-cyan-600" />
                  </span>
                  <span className="font-quicksand text-gray-700 text-base">
                    {f}
                  </span>
                </li>
              ))}
            </ul>

            <Link
              to="/alphabet"
              className="block text-center bg-cyan-500 hover:bg-cyan-600 text-white font-fredoka font-bold text-lg py-3 rounded-2xl shadow-md hover:shadow-lg transition-all"
            >
              Start Free
            </Link>
          </motion.div>

          {/* Premium Plan */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
            whileHover={{ y: -4 }}
            className="relative bg-white rounded-3xl border-2 border-amber-300 shadow-lg hover:shadow-2xl transition-all p-6 md:p-7 flex flex-col h-full"
          >
            <div className="absolute -top-3 right-5 bg-amber-400 text-amber-900 font-fredoka font-bold text-xs px-3 py-1.5 rounded-full shadow-md flex items-center gap-1">
              <Star className="w-3 h-3" fill="currentColor" />
              Best Value
            </div>

            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 rounded-2xl bg-amber-100 flex items-center justify-center">
                <Crown className="w-6 h-6 text-amber-600" />
              </div>
              <div>
                <h3 className="font-fredoka font-bold text-2xl text-gray-800">
                  Premium Plan 👑
                </h3>
              </div>
            </div>

            <div className="mb-5">
              <span className="text-4xl md:text-5xl font-fredoka font-bold text-gray-900">
                ₹499
              </span>
              <span className="text-gray-500 font-quicksand ml-2">/year</span>
            </div>

            <ul className="space-y-3 mb-6 flex-grow">
              {premiumFeatures.map((f) => (
                <li key={f} className="flex items-center gap-3">
                  <span className="w-6 h-6 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                    <Check className="w-4 h-4 text-amber-600" />
                  </span>
                  <span className="font-quicksand text-gray-700 text-base">
                    {f}
                  </span>
                </li>
              ))}
            </ul>

            <Link
              to="/pricing"
              className="block text-center bg-amber-400 hover:bg-amber-500 text-amber-900 font-fredoka font-bold text-lg py-3 rounded-2xl shadow-md hover:shadow-lg transition-all"
            >
              View Plans
            </Link>
          </motion.div>
        </div>

        <p className="text-center text-gray-600 font-quicksand text-sm md:text-base mt-6">
          Safe for kids • Cancel anytime • Learn at your pace
        </p>
      </div>
    </section>
  );
};

export default PlanPreview;
